export default "3-5\n10-14\n16-20\n12-18\n\n1\n5\n8\n11\n17\n32"